const trataAtleta = (codigo) => {
  let novoCodigo = codigo;

  const segundaPosicao = novoCodigo.charAt(1);
  const terceiraPosicao = novoCodigo.charAt(2);

  //coloca zeros antes só se for número. Para viabilizar registro de Tempo ou ponto $

  if (
    segundaPosicao &&
    terceiraPosicao &&
    !isNaN(segundaPosicao) &&
    !isNaN(terceiraPosicao)
  ) {
    // Se ambas forem números, define 'atleta' com esses dois números
    novoCodigo = segundaPosicao + terceiraPosicao;
  } else if (segundaPosicao && !isNaN(segundaPosicao)) {
    // Se apenas a segunda posição for número, define 'atleta' com zero à esquerda
    novoCodigo = "0" + segundaPosicao;
  } else {
    // Caso contrário, define 'atleta' como null - para ge
    novoCodigo = null;
  }

  return novoCodigo;
};

const trataComboAttack = (code) => {
  const codes = {
    X7: ["Q", 3],

    XM: ["Q", 3],
    XL: ["Q", 2],
    X1: ["Q", 3],
    X2: ["Q", 2],
    C1: ["Q", 1],
    C3: ["Q", 3],
    CF: ["N", 2],
    XS: ["N", 2],
    CD: ["N", 2],
    X5: ["T", 4],
    XO: ["T", 5],
    X6: ["T", 2],
    X8: ["T", 1],
    W1: ["T", 1],
    W2: ["T", 2],
    W4: ["T", 4],

    V5: ["H", 4],
    V0: ["H", 5],
    V6: ["H", 2],
    V8: ["H", 1],
    VP: ["H", 6],
    VR: ["H", 5],
    VB: ["H", 1],
    G4: ["H", 4],
    G5: ["H", 5],
    G6: ["H", 4],
    X3: ["M", 3],
    X4: ["M", 2],
    X9: ["M", 4],
    XR: ["S", 5],
    XP: ["S", 6],
    XB: ["S", 1],
    X0: ["S", 5],
    PP: ["O", 2],
  };
  return codes[code] || null;
  // const setterCalls = {
  //   KS: ["E", 2],
  //   K1: ["E", 2],
  //   KM: ["E", 3],
  //   K7: ["E", 7],
  //   KB: ["E", 2],
  //   K2: ["E", 2],
  // };

  const combo = code.slice(0, 2);
  const sz = parseInt(code[2]);
  const ez = parseInt(code[3]);
  const ez2 = code[4];

  return { combo, sz, ez, ez2 };
};

const handleAdvanced = (codeOld) => {
  // *12AH#12

  if (codeOld[6] && !isNaN(parseInt(codeOld[6]))) {
    return codeOld.slice(0, 6) + "__" + codeOld.slice(6);
  } else {
    return codeOld;
  }
};

const trataAdvanced = (cod) => {
  if (cod) {
    const data = {
      combo: cod.slice(0, 2),
      sz: parseInt(cod[2]),
      ez: parseInt(cod[3]),
      ez2: cod[4],
    };
    return data;
  } else {
    return null;
  }
};

const trataInicio = (codigo) => {
  // Lógica para definir 'codigos' com base na primeira letra
  let codigoAtualizado = codigo;
  if (
    codigoAtualizado.charAt(0).toLowerCase() !== "a" &&
    codigoAtualizado.charAt(0).toLowerCase() !== "*"
  ) {
    codigoAtualizado = "*" + codigo;
  }
  // return codigoAtualizado.toUpperCase();
  return codigoAtualizado;
};

const converteCodigo = (codigo) => {
  // Identifica o time da ação
  let codigoAtualizado = trataInicio(codigo);

  if (codigoAtualizado.charAt(1) === "$") {
    codigoAtualizado = codigoAtualizado + "$&H#";
  } else if (isNaN(parseInt(codigoAtualizado.charAt(1)))) {
    // Se o segundo caractere não for um número, devolve o código original
    return codigoAtualizado;
  } else if (
    // Verifica se o terceiro caractere existe e se não é um número
    (codigoAtualizado.charAt(2) && isNaN(codigoAtualizado.charAt(2))) ||
    codigoAtualizado.length === 2
  ) {
    // Insere um zero entre o primeiro e o segundo caractere
    codigoAtualizado =
      codigoAtualizado.slice(0, 1) + "0" + codigoAtualizado.slice(1);
  }
  return codigoAtualizado;
};

const desafioQualidade = (code, skill) => {
  const basic = {
    "#": "/",
    "=": "#",
    "/": "+",
    "+": "/",
    "!": "-",
    "-": "!",
  };
  const block = {
    "#": "<",
    "=": "#",
    "/": "+",
    "+": "/",
    "!": "-",
    "-": "!",
  };
  if (skill === "B") {
    return block[code] || code;
  } else {
    return basic[code] || code;
  }
};
const parFundamento = (code) => {
  const mapeamento = {
    S: "R",
    A: "B",
    B: "A",
  };

  return mapeamento[code] || code;
};

const quality = ["#", "=", "/", "+", "!", "-", "<"];
const skills = ["S", "R", "E", "A", "D", "B", "F"];
const power = ["H", "M", "Q", "T", "U", "N", "O"];
const positions = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

const separaBlocos = (blocos) => {
  const blocosComPontos = [];

  blocos.forEach((bloco) => {
    const partes = bloco.split(".");

    let power1, power2;
    if (partes.length === 2) {
      let [parte1, parte2] = partes; //quebra o bloco em duas partes

      parte1 = converteCodigo(parte1); //numero para duas posicoes

      parte1 = incluiFundamento(parte1, 2);

      const inicioParte1 = parte1.charAt(0);

      const novoBloco2 = `${inicioParte1 === "*" ? "a" : "*"}${parte2}`;

      parte2 = converteCodigo(novoBloco2);
      // const novoSkilB2 = ["B", "D"].includes(parte2.charAt(3))
      const skillBloco2 = parFundamento(parte1.charAt(3));

      parte2 = parte2.slice(0, 3) + skillBloco2 + parte2.slice(3); // incluiu o B

      const tipo = parte2.length === 6 ? 2 : 1;

      parte2 = incluiFundamento(parte2, tipo);

      const qualityBloco1 = desafioQualidade(
        parte2.charAt(5),
        parte2.charAt(3)
      );

      parte1 = parte1.slice(0, 5) + qualityBloco1 + parte1.slice(5);

      const qualityAtfour = quality.includes(parte2.charAt(5));

      if (!qualityAtfour) {
        parte2 = parte2.slice(0, 4) + parte1.charAt(5) + parte2.slice(4);
      }

      parte2 = parte2.slice(0, 4) + parte1.charAt(4) + parte2.slice(5); //incluiu H antes do b
      if (positions.includes(parte1[6]) && positions.includes(parte2[6])) {
        const p1 = parte1[6];
        const p2 = parte2.slice(6, 8);
        parte1 = parte1.slice(0, 6) + p1 + p2 + parte1.slice(7);
        parte2 = parte2.slice(0, 6) + p1 + p2 + parte2.slice(7);

        parte1 = handleAdvanced(parte1);
        parte2 = handleAdvanced(parte2);
      }
      blocosComPontos.push(parte1, parte2);
    } else {
      const novoBloco = incluiFundamento(bloco, 1);

      const blocoAdvanced = handleAdvanced(novoBloco);
      blocosComPontos.push(blocoAdvanced);
    }
  });

  return blocosComPontos;
};

const incluiFundamento = (bloco, tipo) => {
  let power1;
  let codigoConvertido = converteCodigo(bloco); // já tem é *00 ou a00
  const codCombo = codigoConvertido.slice(3, 5);
  const combo = trataComboAttack(codCombo);
  let skill;
  let sz;

  if (!combo) {
    //nao está com combo, incluio  skill padrao, caso já nao tenha
    skill = skills.includes(codigoConvertido.charAt(3));
    if (!skill) {
      codigoConvertido =
        codigoConvertido.slice(0, 3) + "A" + codigoConvertido.slice(3);
    }
  } else {
    // sendo combo, inlui skill, power e zona inicial
    codigoConvertido =
      codigoConvertido.slice(0, 3) +
      "A" +
      combo[0] +
      codigoConvertido?.charAt(5) +
      codCombo +
      combo[1] +
      codigoConvertido.slice(6);
  }

  if (isNaN(parseInt(codigoConvertido.charAt(1)))) {
    return codigoConvertido;
  }

  power1 = power.includes(codigoConvertido.charAt(4)) ? "" : "H";
  const novoBloco =
    codigoConvertido.slice(0, 4) +
    power1 +
    // qualityBloco1 +
    codigoConvertido.slice(4);

  if (!quality.includes(novoBloco.charAt(5)) && tipo === 1) {
    codigoConvertido = novoBloco.slice(0, 5) + "!" + novoBloco.slice(5);
  } else {
    codigoConvertido = novoBloco;
  }
  return codigoConvertido;
};

const trocaLibero = (numbers, team, tiimeSacador, teamType) => {
  // Clonar para evitar mutação direta
  const updatedNumbers = [...numbers];

  // Posições a verificar: sempre verifica 4 e 5
  const positionsAlwaysCheck = [4, 5];

  positionsAlwaysCheck.forEach((pos) => {
    const number = numbers[pos];
    const playerData = team?.find((p) => String(p.number) === String(number));
    const playerFunction = playerData?.function || null;

    if (playerFunction === "c") {
      // Troca com a posição 6 (index 6)
      const temp = updatedNumbers[pos];
      updatedNumbers[pos] = updatedNumbers[6];
      updatedNumbers[6] = temp;
    }
  });

  // Agora verifica posição 0 **só se** for o time sacador correto
  const isCorrectTeam =
    (teamType === "home" && tiimeSacador === "a") ||
    (teamType === "away" && tiimeSacador === "*");

  if (isCorrectTeam) {
    const number = numbers[0];
    const playerData = team?.find((p) => String(p.number) === String(number));
    const playerFunction = playerData?.function || null;

    if (playerFunction === "c") {
      // Troca com a posição 6 (index 6)
      const temp = updatedNumbers[0];
      updatedNumbers[0] = updatedNumbers[6];
      updatedNumbers[6] = temp;
    }
  }

  return updatedNumbers;
};

const getAtletaPorNumero = (numero, equipe) => {
  if (!numero || !equipe) return null;

  // const atleta = equipe.find((jogador) => jogador.number === numero);
  const atleta = equipe.find(
    (jogador) => String(jogador.number) === String(numero)
  );

  if (!atleta) return null;

  return {
    name: atleta.name,
    nomeCompleto: `${atleta.name} ${atleta.surname}`,
    funcao: atleta.function, // "líbero", "levantador", etc.
  };
};

const corPorFuncao = (funcao) => {
  switch (funcao?.toLowerCase()) {
    case "l":
    case "libero":
      return "#FFD700"; // amarelo
    case "levantador":
      return "#1E90FF"; // azul
    case "oposto":
      return "#FF4500"; // laranja
    case "central":
      return "#32CD32"; // verde
    case "ponteiro":
      return "#800080"; // roxo
    default:
      return "gray";
  }
};

export {
  trataAtleta,
  trataInicio,
  converteCodigo,
  separaBlocos,
  trocaLibero,
  getAtletaPorNumero,
  corPorFuncao,
  handleAdvanced,
  trataAdvanced,
  trataComboAttack,
};
